import GoogleAdsEvent from './GoogleAdsEvent';

declare var gtag: any;
declare var keeper: any;
declare var $: any;

const consoleLogGa = (message: string, data?: GoogleAdsEvent) => {
    // Don't log if it's production.
    const isProd = window.location.hostname === 'www.keepersecurity.com' ? true : false;
    if (!isProd) {
        if (data) console.log(message, data);
        else console.log(message);
    }
};

export const sendGoogleAdsEvent = (
    tag: string,
    label: string,
    value?: number,
    currency?: string,
    transactionId?: string
) => {
    const gAdsTag = tag || 'AW-000000000';
    const gAdsSendTo = `${gAdsTag}/${label}`;
    const gAdsEvent = new GoogleAdsEvent(gAdsSendTo, value, currency, transactionId);

    if (typeof gtag == 'undefined') {
        // Wait for page load to send GA event.
        window.addEventListener('load', () => {
            if (gtag) {
                gtag('event', 'conversion', gAdsEvent.event);
                //consoleLogGa('gtag_event', gAdsEvent);
            } else {
                // Wait a second to see if GA loads and try again.
                setTimeout(() => {
                    if (gtag) {
                        gtag('event', 'conversion', gAdsEvent.event);
                        //consoleLogGa('gtag_event', gAdsEvent);
                    } else {
                        //consoleLogGa('gtag never loaded');
                    }
                }, 1000);
            }
        });
    } else {
        gtag('event', 'conversion', gAdsEvent.event);
        //consoleLogGa('gtag_event', gAdsEvent);
    }
};
